export class SignFileInfo {
  changeIdentifier: string;
  sequenceNumber: string;
}



// WEBPACK FOOTER //
// ./src/app/services/document-signing/sign-file-info.ts